export default __webpack_public_path__ + "static/media/google-logo.bbb69352.svg";